//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'PrefixMixin',
  methods: {
    prefix: function prefix(_prefix, content) {
      return _prefix + '_' + content;
    }
  }
};